<template>
  <div v-if="internalValue!==undefined" class="radio-scale-wrapp">
    <!-- <div class="title">{{ $t('transparency') }}</div> -->
    <div class="radio-options">
      <div class="radio-option">
        <input
          id="gradient"
          type="radio"
          name="scale-legend"
          value="gradient"
          :checked="internalValue.scaleOption==='gradient'"
          @click="changeScaleMaps"
        >
        <label for="gradient">
          <div class="color-gradient" :style="backgroundGradient" />
        </label>
      </div>
      <div class="radio-option">
        <input
          id="steps"
          type="radio"
          name="scale-legend"
          value="steps"
          :checked="internalValue.scaleOption==='steps'"
          @click="changeScaleMaps"
        >
        <label for="steps">
          <div class="steps-wrapper">
            <div
              v-for="step in steps" 
              :key="step.color"
              class="step-box"
              :style="'backgroundColor: ' + step.color"
            />
          </div>
        </label>
      </div>
    </div>
    <div v-if="internalValue.scaleOption === 'steps'" class="steps-menu-wrap">
      <div class="subtitle">{{ $t('steps') }}</div>
      <div class="steps-wrap">
        <input
          v-model="internalValue.scaleSteps"
          type="number"
          :min="min"
          :max="max"
        >
        <select v-model="internalValue.interpolationType">
          <option v-for="o in steppingOptions" :key="o.id" :value="o.id">{{ o.label }}</option>
        </select>
      </div>
    </div>

    <div v-if="internalValue.scaleOption === 'steps' && internalValue.interpolationType==='custom'" class="custom-steps">
      <div class="title">{{ $t('custom_steps') }}</div>
      <div v-for="(step,i) in internalCustomSteps" :key="i" class="custom-step">
        <div class="step-color" :style="{backgroundColor: step.color}" />
        <!-- <input
          v-if="i===0"
          value="min"
          class="value no-input"
          :disabled="true"
        > -->
        <input
          :value="step.min"
          class="value"
          @change="(e)=>updateCustomStep(i,'min',+e.target.value)"
          @focus="$event.target.select()"
        >
        -
        <!-- <input
          v-if="i===internalCustomSteps.length-1"
          value="max"
          class="value no-input"
          :disabled="true"
        >  -->
        <input
          :value="step.max"
          class="value"
          @change="(e)=>updateCustomStep(i,'max',+e.target.value)"
          @focus="$event.target.select()"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { range as d3_range, extent as d3_extent } from 'd3-array'
import { scaleLinear as d3_scaleLinear } from 'd3-scale'
import { cssGradient } from '../../utils/colorUtils'
import { t } from '@/i18n'
export default {
  components: {},
  model: {
    prop: 'config',
    event: 'change',
  },
  props: {
    config: [Object],
    allTimeValues: Array,
    // defaultMapSteps: [Number],
    // colorRange: [Array],
  },
  data() {
    return {
      // defaultSteps: this.defaultMapSteps ? this.defaultMapSteps : 5,
      min: 2,
      max: 10,
      internalCustomSteps: this.config.customSteps
        ? JSON.parse(JSON.stringify(this.config.customSteps))
        : null,
      internalValue: null,
      steppingOptions: [
        {
          label: t('map_step_linear'),
          id: 'linear',
        },
        {
          label: t('map_step_rounded'),
          id: 'rounded',
        },
        {
          label: t('map_step_quantile'),
          id: 'quantiles',
        },
        {
          label: t('map_step_breaks'),
          id: 'jenks',
        },
        {
          label: t('map_step_custom'),
          id: 'custom',
        },
      ],
    }
  },
  computed: {
    backgroundGradient() {
      return `background: ${cssGradient(this.internalValue.colorRange)}`
    },
    // internalValue: {
    //   get() {
    //     return JSON.parse(JSON.stringify(this.config))
    //   },
    //   set(value) {
    //     this.$nextTick(() => {
    //       this.$emit('change', value)
    //     })
    //   },
    // },
    steps() {
      let linearScale = d3_scaleLinear()
        .domain(d3_range(0, 1.001, 1 / (this.internalValue.colorRange.length - 1)))
        .range(this.internalValue.colorRange)
      return d3_range(0, 1.001, 1 / (this.internalValue.scaleSteps - 1)).map(c => {
        return {
          color: linearScale(c),
        }
      })
    },
  },
  watch: {
    config: {
      handler() {
        this.internalValue = JSON.parse(JSON.stringify(this.config))
      },
      immediate: true,
    },
    internalValue: {
      handler(value) {
        this.$nextTick(() => {
          // this.$emit('change', value)
          if (JSON.stringify(value) !== JSON.stringify(this.config)) this.$emit('change', value)
        })
      },
      deep: true,
    },
    'internalValue.colorRange': {
      handler() {
        if (this.internalCustomSteps) {
          let linearScale = d3_scaleLinear()
            .domain(d3_range(0, 1.001, 1 / (this.internalValue.colorRange.length - 1)))
            .range(this.internalValue.colorRange)
          this.internalCustomSteps.forEach((step, i) => {
            step.color = linearScale(i / (this.internalValue.scaleSteps - 1))
          })
        }
      },
    },
    'internalValue.interpolationType': {
      handler() {
        this.resetSteps()
      },
    },
    'internalValue.scaleSteps': {
      handler() {
        this.resetSteps()
      },
    },
    internalCustomSteps: {
      handler(value) {
        // this.sanitizeSteps(value)
        this.internalValue.customSteps = JSON.parse(JSON.stringify(value))
      },
      deep: true,
    },
  },
  methods: {
    roundStep(value) {
      if (value < 1) return value.toFixed(2)
      else if (value < 100) return value.toFixed(1)
      else return Math.round(value)
    },
    resetSteps() {
      if (this.internalValue.interpolationType !== 'custom') {
        return null
      } else {
        let linearScale = d3_scaleLinear()
          .domain(d3_range(0, 1.001, 1 / (this.internalValue.colorRange.length - 1)))
          .range(this.internalValue.colorRange)
        let extent = d3_extent(this.allTimeValues)
        let stepValues = d3_range(
          extent[0],
          extent[1],
          (extent[1] - extent[0]) / this.internalValue.scaleSteps
        )
        this.internalCustomSteps = stepValues.map((val, i) => {
          return {
            id: i,
            min: +this.roundStep(val),
            max: +this.roundStep(stepValues[i + 1] || extent[1]),
            color: linearScale(i / (this.internalValue.scaleSteps - 1)),
          }
        })
      }
    },
    updateCustomStep(step, key, value) {
      this.internalCustomSteps[step][key] = value
      this.sanitizeSteps(step, key)
    },
    sanitizeSteps(preservedStep, preservedKey) {
      let steps = this.internalCustomSteps
      if (preservedStep !== undefined && preservedKey !== undefined) {
        let downFrom = null
        let upFrom = null
        if (preservedKey === 'min' && preservedStep > 0) {
          downFrom = preservedStep - 1
          if (steps[preservedStep].max < steps[preservedStep].min) {
            steps[preservedStep].max = steps[preservedStep].min
            upFrom = preservedStep + 1
          }
        } else if (preservedKey === 'max' && preservedStep < steps.length - 1) {
          upFrom = preservedStep + 1
          if (steps[preservedStep].min > steps[preservedStep].max) {
            steps[preservedStep].min = steps[preservedStep].max
            downFrom = preservedStep - 1
          }
        }
        if (downFrom !== null) {
          let stepToFix = downFrom
          while (stepToFix > -1 && steps[stepToFix].max !== steps[stepToFix + 1].min) {
            steps[stepToFix].max = steps[stepToFix + 1].min
            if (steps[stepToFix].max < steps[stepToFix].min)
              steps[stepToFix].min = steps[stepToFix].max
            stepToFix -= 1
          }
        }
        if (upFrom !== null) {
          let stepToFix = upFrom
          while (stepToFix < steps.length && steps[stepToFix].min !== steps[stepToFix - 1].max) {
            steps[stepToFix].min = steps[stepToFix - 1].max
            if (steps[stepToFix].min > steps[stepToFix].max)
              steps[stepToFix].max = steps[stepToFix].min
            stepToFix += 1
          }
        }
      }
    },
    changeSteps(num) {
      var steps = num
      if (steps > this.max) steps = this.max
      if (steps < this.min) steps = this.min
      this.internalValue.scaleSteps = steps
      // this.$emit('change-num-steps', steps)
    },
    // changeInterpolation(e) {
    //   // this.$emit('change-interpolation', e.target.value)
    // },
    changeScaleMaps(e) {
      // if (e.target.defaultValue !== this.internalValue.scaleOption) {
      this.internalValue.scaleOption = e.target.defaultValue
      // }
    },
  },
}
</script>

<style lang="stylus" scoped>
.radio-scale-wrapp
  margin-bottom: vw(20px)

  .steps-menu-wrap
    display: flex
    flex-direction: column
    margin-top: vw(15px)

    .subtitle
      m-font-size(14, 20)
      margin-bottom: vw(10px)

    .steps-wrap
      display: flex
      padding: 0 vw(5px)
      gap: vw(8px)

      select
        width: 100%

  .title
    m-font-size(14, 20)
    margin-bottom: vw(10px)
    font-weight: 600

  .radio-options
    display: flex
    flex-direction: column
    margin-top: vw(25px)
    gap: vw(15px)

    .radio-option
      display: flex

      label
        width: 88%

      .color-gradient
        margin-left: vw(5px)
        width: 100%
        height: vw(25px)

      .steps-wrapper
        display: flex
        margin-left: vw(5px)
        width: 100%
        height: vw(25px)
        gap: vw(5px)

        .step-box
          flex-grow: 1
          height: 100%

  .custom-steps
    display: flex
    flex-direction: column

    .custom-step
      display: flex
      align-items: center

      // margin: vw(4px)
      .step-color
        margin-right: vw(4px)
        width: vw(20px)
        height: vw(20px)
        border-radius: vw(20px)

      .value
        margin: vw(4px)
        width: vw(70px)
</style>
